import type { FormEvent, ReactNode } from 'react'

import Honeypot from '../fields/Honeypot'

type Props = {
  onSubmit: (e: FormEvent<HTMLFormElement>) => void
  children: ReactNode
}

const Form = ({ onSubmit, children }: Props) => (
  <form onSubmit={onSubmit}>
    <Honeypot />
    {children}
  </form>
)

export default Form
